const SouscriptionInformationsExtraFormRepresentative = () => null;

export default SouscriptionInformationsExtraFormRepresentative;
